import React from 'react';
import SearchBar from '../Components/SearchBar';
import { getAllInvoices, getDueAmounts, setInvoicePaymentMedium, updateStatusForFinance, GetAllInvoicesForSupplier, } from '../store/actions/invoiceActions';
import { getallMasterData, GetFilterList } from '../store/actions/masterActions';
import { connect } from 'react-redux'
import formatDate from '../Classes/FormatDate'
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import DropdownFlat from '../Components/DropdownFlat'
import PaginationComponent from '../Components/PaginationComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import MultiSelect from "react-multi-select-component";
import Select from "react-select"
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import DocumentCommentAdvancePopUp from '../Components/DocumentCommentAdvancePopUp';
import authInstance from '../Classes/AuthHandler';
import { GetAllPOListByUserId, GetPOLineItemByPOId, postMapPaymentAcknowledgementDocumentIDsToInvoice, PaymentTermDocumentsApprovalByPMs, getPaymentTermDocuments, getProjectAllocationByUserId } from '../store/actions/poDetailsActions';
import TableComp from '../Components/ReusableTable'
import { Table } from 'react-bootstrap';
// import { CSVLink } from "react-csv";
import { CircularProgressbar, CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import env from '../ENV';
import Loading from '../Components/Loader';
import { red } from '@material-ui/core/colors';
import AuthHandler from '../Classes/AuthHandler';
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;


class ReqPayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoicetabledata: [],
            supplierName: "ABC Tech Inc.",
            select: true,
            checked: [],
            checkedPOID: [],
            selectedDropdowndata: "",
            selectAll: false,
            modal: false,
            paymentMethod: [],
            selectedpaymentmethod: "",
            dropdownpodata: "",
            select: false,
            selected: [],
            checkedArray: [],
            budget: "",
            Curr_Day: "",
            finalLastDay: "",
            DocumentCommentAdvancePopUpModal: false,
            varId: "",
            // dropdowndata: [{ value: 1, invoice: "ABC " },
            //                { value: 2, invoice: "CDE " },
            //                { value: 3, invoice: "EFG " },
            //               ],
            invoiceTableData: [],
            EditedUtrNo: "",
            csvData: [],
            loading: false,
            searchTerm: new URLSearchParams(this.props.location.search).get("searchTerm") ? new URLSearchParams(this.props.location.search).get("searchTerm") : "",
            currentPage: new URLSearchParams(this.props.location.search).get("currentPage") ? new URLSearchParams(this.props.location.search).get("currentPage") : 1,
            totalPos: 0,
            posPerpage: new URLSearchParams(this.props.location.search).get("posPerpage") ? new URLSearchParams(this.props.location.search).get("posPerpage") : 10,
            searchForOptions: [
                {
                    label: 'Vendor Name', value: 'Vendor Name'
                },
                {
                    label: 'Plant Code', value: 'Plant Code'
                },
                {
                    label: 'PO Number', value: 'PO Number'
                },
                {
                    label: 'Invoice Number', value: 'Invoice Number'
                },
                {
                    label: 'Project No.', value: 'WBS'
                },
            ],
            searchForItem: [],
            searchFor: new URLSearchParams(this.props.location.search).get("searchFor") ? new URLSearchParams(this.props.location.search).get("searchFor") : "",
            isShowFilter: false,
            finalvendorlist: [],
            finalpos: [],
            finalwbsno: [],
            finalplantcode: [],
            PlantCode: [],
            WBSCode: [],
            POSAPId: [],
            VendorName: [],
            sortByPlantCode: [],
            sortByWBS: [],
            sortByPo: [],
            sortByVendor: [],
        }
        this.togglebutton = this.togglebutton.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this);
        this.modal = this.modal.bind(this);
        this.uploadmodal = this.uploadmodal.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handlesendtofinance = this.handlesendtofinance.bind(this);
        this.handlebudgetchange = this.handlebudgetchange.bind(this);
        this.handlesavebudget = this.handlesavebudget.bind(this);
        this.DocumentCommentAdvancePopUpModal = this.DocumentCommentAdvancePopUpModal.bind(this);
        this.csvLinkEl = React.createRef();

    }

    async modalSubmit() {
        var role = Object.keys(authInstance.getRoles())[0]
        var group = Object.keys(authInstance.getGroups())[0]

        let array = []
        let uniqueArray = [...new Set(this.state.checkedArray)];
        uniqueArray.map(item => {
            let temp = {
                invoiceId: item,
                paymentMediumId: this.state.selectedpaymentmethod
            }
            array.push(temp)
        })
        //console.log('*******',this.props.invoices.allInvoices.recordset)


        console.log(array, '&&&&&&&&&&&&&&&&&&&&')

        await this.props.setInvoicePaymentMedium({
            invoiceIdVsPaymentMedium: array
        })


        this.modal()
        this.props.getAllInvoices(role, group)
    }

    handlesendtofinance() {
        var role = Object.keys(authInstance.getRoles())[0]
        var group = Object.keys(authInstance.getGroups())[0]
        console.log("Hi")
        let array = []
        let uniqueArray = [...new Set(this.state.checkedArray)];
        uniqueArray.map(item => {
            console.log(item)
            array.push(item)
        })

        console.log(array)

        this.props.updateStatusForFinance(role, group, array)
        this.props.getAllInvoices(role, group)
    }

    handlebudgetchange(e) {
        console.log("jhi")
        console.log(e.target.value)
        this.setState({ budget: e.target.value })
    }

    handlesavebudget() {
        console.log(this.state.budget, this.state.Curr_Day, this.state.finalLastDay)

    }
    //  onclickDownload = async (documentID) => {
    //     // var url = FILESERVER_ROOT_URL + "files/Documents/" + documentID + "/download"
    //     // window.location.href = url
    //   }

    modal() {
        this.setState({ modal: !this.state.modal });
        if (this.state.uploadModal == true) {
            this.setState({ uploadModal: !this.state.uploadModal });
        }
        if (this.state.modal == true) {
            this.setState(
                { opacity: "" }
            )

        }
        else {
            this.setState(
                { opacity: "0.2" }
            )

        }
    }


    handleSelect = (e) => {
        this.setState({
            selectedpaymentmethod: e.target.value
        })
    }

    handleFileInput = (event) => {
        let reviseForm = this.state.reviseForm

        reviseForm.file.push(event.target.files[0])
        this.setState({ reviseForm });
        console.log(this.state.reviseForm, 'file::')
    }
    componentDidMount = async () => {
        let roles = AuthHandler.getRoles()
        let userId = AuthHandler.getUserID()
        if (roles[12]) {
            let sortByWBS = []
            let WBSCode = []
            await this.props.getProjectAllocationByUserId({ UserId: userId })
            let ProjectCodes = await this.props.poDetails.getProjectAllocationByUserId
            if (ProjectCodes.length > 0) {
                ProjectCodes.map((elem) => {
                    sortByWBS.push(elem.ProjectCode)
                    WBSCode.push({ label: elem.ProjectCode, value: elem.ProjectCode })
                })
            }
            await this.setState({ sortByWBS, WBSCode })
        }
        await this.filterData()
        await this.getFilterList()
        await this.setState({ loading:false })
    }

    handleChange = () => {

        try {
            let selected = this.state.selected;
            let select = !this.state.select;
            var checkedArray = this.state.checkedArray
            //console.log(select,'??????////')
            this.props.invoices.allInvoices.recordset.map((item, index) => {
                selected[item.InvoiceId] = select;
                if (select == true) {
                    checkedArray.push(item.InvoiceId)
                } else {
                    checkedArray = []
                }
            });


            this.setState({ selected: selected, select: select, checkedArray });
        } catch (e) {
            console.log(e);
        }

    };


    handleClickPoDropdown = (e) => {
        this.setState({ dropdownpodata: e.target.value })
        // if(this.state.dropdownpodata){
        this.props.GetPOLineItemByPOId(e.target.value)
        // }
    }

    handleClickMultiPoDropdown = (e) => {
        // this.props.GetPOLineItemByPOId(e.target)
        this.setState({
            selectedDropdowndata: e
        })
        console.log("selected", e)
    }


    togglebutton = async (Index) => {
        console.log("ooopopopop")
        var multiCollapseIndex = this.state.multiCollapseIndex
        if (multiCollapseIndex != Index || multiCollapseIndex == '') {
            await this.setState({ multiCollapseIndex: Index })
        }
        console.log(this.state.multiCollapseIndex, "multiCollapseIndex")
    }

    handleSingleCheckboxChange = index => {

        var checkedArray = this.state.checkedArray
        let selected = this.state.selected;
        let status = index in selected ? !selected[index] : true
        selected[index] = status
        if (selected[index] == true) {
            checkedArray.push(index)
        } else {
            var index = checkedArray.indexOf(index);
            if (index !== -1) {
                checkedArray.splice(index, 1);
            }
        }
        console.log(checkedArray, '**********', index, selected)
        this.setState({ selected, checkedArray });


    };

    fetchDate(date) {
        let dd = date.getDate().toString()
        let mm = (date.getMonth() + 1).toString()
        if (dd.length < 2)
            dd = "0" + dd
        if (mm.length < 2)
            mm = "0" + mm
        let finalDate = dd + "/" + mm + "/" + date.getFullYear();
        return finalDate;
    }

    daysInMonth(month, year) {
        return new Date(year, month, 0).getDate();
    }

    async rowClick(index) {
        let id = this.props.invoices.getAllInvoicesforSupplier.recordset[index].InvoiceId
        console.log(id, "idddd")
        this.setState({ varId: id })
        await this.DocumentCommentAdvancePopUpModal(id)
    }

    DocumentCommentAdvancePopUpModal() {
        this.setState({ DocumentCommentAdvancePopUpModal: !this.state.DocumentCommentAdvancePopUpModal });
        this.setState({ RetentionDocumentsModal: false });
        if (this.state.DocumentCommentAdvancePopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    toggleDocumentCommentAdvancePopUpModal = async (e) => {
        await this.setState({ DocumentCommentAdvancePopUpModal: !this.state.DocumentCommentAdvancePopUpModal });
        if (this.state.DocumentCommentAdvancePopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2", varId: "" }
            )
        }
    }

    uploadmodal() {
        this.setState({ uploadModal: !this.state.uploadModal });
        if (this.state.uploadModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    Submitmodal = async () => {
        var input = {
            podata: this.state.dropdownpodata,
            itemdata: this.state.selectedDropdowndata
        }
        console.log(input, "Selected Values::")

        window.location.reload()
        this.modal()
    }
    handleUtrNo = async (event) => {
        await this.setState({ EditedUtrNo: event.target.value })
    }
    handleClickSaveUtrNo = async (invoiceId) => {
        await this.props.postMapPaymentAcknowledgementDocumentIDsToInvoice(
            invoiceId,
            "",
            null,
            0,
            this.state.EditedUtrNo
        )
    }
    handleISearch = (e) => {
        let searchTerm = e.target.value
        this.setState({
            searchTerm
        })
        console.log(this.state.searchTerm)
    }
    handleSearching = async (e) => {
        await this.filterData()
    }
    handleSelectSearchFor = async (value) => {
        let searchFor = value
        let searchForItem = [
            {
                label: value, value: value
            }
        ]
        await this.setState({ searchFor, searchForItem })
    }
    handleSelectPoPerPage = async (e) => {
        await this.setState({ posPerpage: e.value })
        await this.filterData()
    }
    handleClick = async (event) => {
        let currentPage = Number(event.target.id)
        if (!event.target.id) {
            currentPage = event.target.offsetParent.id
        }
        await this.setState({ currentPage })
        await this.filterData()
    }
    clearFilter = async () => {
        await this.setState({
            currentPage: 1,
            posPerpage: 10,
            searchTerm: '',
            searchFor: '',
            searchForItem: [],
            PlantCode: [],
            WBSCode: [],
            POSAPId: [],
            VendorName: [],
            sortByPlantCode: [],
            sortByWBS: [],
            sortByPo: [],
            sortByVendor: [],
        })
        await this.filterData()
    }

    // getInvoices = async () => {
        // await this.setState({
        //     loading: true
        // });
        // var UserId = authInstance.getUserID()
        // var role = authInstance.getRoles()
        // let searchData = {
        //     currentPage: 1,
        //     posPerpage: 100000000000000,
        //     searchTerm: '',
        //     searchFor: '',
        //     UserId: role[5] ? UserId : 0
        // }
        // let csvData = []
        // await this.props.GetAllInvoicesForSupplier(searchData)
        // let invoiceTableData = await this.props.invoices.getAllInvoicesforSupplier.recordset.filter(data => data.InvoiceDocId != null && data.approvalStatus !== null && data.approvalStatus !== 0)
        // for (let i = 0; i < invoiceTableData.length; i++) {
        //     const element = invoiceTableData[i];
        //     let Projectcode = element.ProjectCode ? element.ProjectCode.includes('ET') ? (element.ProjectCode).slice(0, 11) : (element.ProjectCode).slice(0, 6) : ''
        //     await csvData.push({
        //         "Vendor Name": element.VendorName,
        //         "Plant Code": element.PlantCode,
        //         "Project Code": Projectcode,
        //         "PO No": element.POSAPId,
        //         "Invoice No": element.InvoiceNo,
        //         "Invoice Date": element.InvoiceDate ? dateFormater(element.InvoiceDate) : "",
        //         "Due Date": element.DueDate ? dateFormater(element.DueDate) : "",
        //         "Invoice Amount(INR)": element.InvoiceAmountinINR ? numberWithCommas(element.InvoiceAmountinINR) : "",
        //         "Net Payable": element.NetPayableAmount ? numberWithCommas(element.NetPayableAmount) : "",
        //         "Paid Amount": element.TotalPaidAmount ? numberWithCommas(element.TotalPaidAmount) : "0",
        //         "Final Approval": element.ApprovalDate ? dateFormater(element.ApprovalDate) : "",
        //         "Payment Date": element.paymentDate ? dateFormater(element.paymentDate) : "",
        //         "Invoice Type": element.TypeFor ? element.InvoiceTypeName + ' against ' + element.TypeFor : element.InvoiceTypeName,
        //         "Vendor Type": element.SSIType == "" ? "NON MSME" : "MSME",
        //         "Invoice Amount": element.CurrencyType + ' ' + numberWithCommas(element.InvoiceAmount),
        //         "Advance Deduction": element.CurrencyType + ' ' + (element.AdvanceDeduction && element.AdvanceDeduction != null ? numberWithCommas(element.AdvanceDeduction) : '0.00'),
        //         "Retention Deduction": element.CurrencyType + ' ' + (element.RetentionDeduction && element.RetentionDeduction != null ? numberWithCommas(element.RetentionDeduction) : '0.00'),
        //         "LD Deduction": element.CurrencyType + ' ' + (element.LDDeduction && element.LDDeduction != null ? numberWithCommas(element.LDDeduction) : '0.00'),
        //         "TDS Deduction": element.CurrencyType + ' ' + (element.TDSDeduction && element.TDSDeduction != null ? numberWithCommas(element.TDSDeduction) : '0.00'),
        //         "Others Deduction": element.CurrencyType + ' ' + (element.OthersDeduction && element.OthersDeduction != null ? numberWithCommas(element.OthersDeduction) : '0.00'),
        //         "Reason For Others": element.ReasonForOthersDeduction ? element.ReasonForOthersDeduction : '',
        //         "Vendor Address": element.VendorAddress + ',' + element.VendorAddress1 + ',' + element.VendorAddress2,
        //         "Vendor GSTIn": element.VendorGstin,
        //         "Utr No": element.utrNo,
        //         "SAP Doc no": element.SAPDocNo,
        //         "SAP Doc Date": element.SAPDocDate ? dateFormater(element.SAPDocDate) : '',
        //         "Payment Method": element.PaymentMediumName,
        //         "Status": element.InvoiceStatusName,
        //     })
        // }
        // await this.setState({ csvData, loading: false })
        // await this.csvLinkEl.current.link.click();
    // }
    filterData = async () => {
        await this.setState({ loading: true })
        let csvData = []
        var UserId = authInstance.getUserID()
        var role = authInstance.getRoles()
        var group = authInstance.getGroups()
        let searchData = {
            currentPage: this.state.currentPage,
            posPerpage: this.state.posPerpage,
            searchTerm: this.state.searchTerm,
            searchFor: this.state.searchFor,
            UserId: role[5] ? UserId : 0,
            sortByPlantCode: this.state.sortByPlantCode,
            sortByWBS: this.state.sortByWBS,
            sortByPo: this.state.sortByPo,
            sortByVendor: this.state.sortByVendor,
        }
        this.props.history.push({
            pathname: '/AdvancedReceivePayments',
            search: "?" + new URLSearchParams(searchData).toString()
        })
        console.log(searchData, "API Call -Store")
        await this.props.GetAllInvoicesForSupplier(searchData)
        var date = new Date();
        var Curr_Day = this.fetchDate(date)
        var lastDay = new Date(date.getFullYear(), date.getMonth(), this.daysInMonth(date.getMonth() + 1, date.getFullYear()));
        var finalLastDay = this.fetchDate(lastDay)
        await this.setState({ Curr_Day, finalLastDay })
        // if(this.state.dropdownpodata){
        // this.props.GetPOLineItemByPOId(this.state.dropdownpodata)
        // }
        if (this.props.invoices.loading == false && this.props.invoices.getAllInvoicesforSupplier && this.props.invoices.getAllInvoicesforSupplier.recordset && this.props.invoices.getAllInvoicesforSupplier.recordset.length > 0) {
            let invoiceTableData = await this.props.invoices.getAllInvoicesforSupplier.recordset.filter(data => data.InvoiceDocId != null && data.approvalStatus !== null && data.approvalStatus !== 0)
            let totalPos = await this.props.invoices.getAllInvoicesforSupplier.totalcount
            for (let i = 0; i < invoiceTableData.length; i++) {
                const element = invoiceTableData[i];

                // }
                // await invoiceTableData.map(async (element) => {
                await this.props.PaymentTermDocumentsApprovalByPMs(invoiceTableData[i].PurchaseOrderId)
                await this.props.getPaymentTermDocuments(invoiceTableData[i].PurchaseOrderId)
                let approvalDetails = await this.props.allpo.paymentTermApprovalByCPMandTPM.recordsets[0].filter((item) => item.PoId === invoiceTableData[i].PurchaseOrderId && (item.TypeFor === invoiceTableData[i].TypeFor || item.TypeFor == null) && item.PaymentType === invoiceTableData[i].PaymentType)
                let approvalDetailsPartial = await this.props.allpo.paymentTermApprovalByCPMandTPM.recordsets[1].filter((item) => item.PoId === invoiceTableData[i].PurchaseOrderId && (item.TypeFor === invoiceTableData[i].TypeFor || item.TypeFor == null) && item.PaymentType === invoiceTableData[i].PaymentType)
                console.log(this.props.allpo.paymentTermApprovalByCPMandTPM.recordsets[0], this.props.allpo.paymentTermDocuments.recordsets[0], invoiceTableData[i].InvoiceNo)
                let ApprovalDepartments = []
                if (this.props.allpo.paymentTermDocuments.recordsets && this.props.allpo.paymentTermDocuments.recordsets.length > 0) {
                    if (this.props.allpo.paymentTermDocuments.recordsets[3] && this.props.allpo.paymentTermDocuments.recordsets[3].length > 0 && this.props.allpo.paymentTermDocuments.recordsets[3].find((elem) => elem.DocumentId == parseInt(element.InvoiceDocId))) {
                        let Counter = this.props.allpo.paymentTermDocuments.recordsets[3].find((elem) => elem.DocumentId == parseInt(element.InvoiceDocId)).Counter
                        console.log(Counter, this.props.allpo.paymentTermDocuments.recordsets[3].filter(item => item.Counter == Counter && element.PaymentType == item.PaymentType && (element.TypeFor == item.TypeFor || item.TypeFor == null) && (item.PaymentType == 1 || item.InvoiceId == element.InvoiceId)), "KDKDKDKKDKDKDKD", element.InvoiceNo)
                        this.props.allpo.paymentTermDocuments.recordsets[3].filter(item => item.Counter == Counter && element.PaymentType == item.PaymentType && (element.TypeFor == item.TypeFor || item.TypeFor == null) && (item.PaymentType == 1 || item.InvoiceId == element.InvoiceId)).map(data => {
                            if (data.DocumentTypeId !== 40) { //to exclude order acceptance from approval matrix
                                if (ApprovalDepartments.find(elem => elem.ActingDeptGroupId === data.ActingDeptGroupId)) {
                                    // total Approval count
                                    ApprovalDepartments.find(elem => elem.ActingDeptGroupId === data.ActingDeptGroupId).TotalApprovalCount = ApprovalDepartments.find(elem => elem.ActingDeptGroupId === data.ActingDeptGroupId).TotalApprovalCount + 1

                                    if (data.approvalStatus == 1) { // total approved count
                                        ApprovalDepartments.find(elem => elem.ActingDeptGroupId === data.ActingDeptGroupId).ApprovedCount = ApprovalDepartments.find(elem => elem.ActingDeptGroupId === data.ActingDeptGroupId).ApprovedCount + 1
                                    }
                                } else {
                                    ApprovalDepartments.push({
                                        "ActingDeptGroupId": data.ActingDeptGroupId,
                                        "TotalApprovalCount": 1,
                                        "ShortDeptName": data.ShortDeptName,
                                        "ApprovedCount": data.approvalStatus == 1 ? 1 : 0
                                    })
                                }
                            }
                        })
                    } else {
                        this.props.allpo.paymentTermDocuments.recordsets[0].filter(item => element.PaymentTypeId == item.PaymentType && (element.TypeFor == item.TypeFor || item.TypeFor == null) && (item.PaymentTypeId == 1 || item.InvoiceId == element.InvoiceId)).map(data => {
                            if (data.DocumentTypeId !== 40) { //to exclude order acceptance from approval matrix
                                if (ApprovalDepartments.find(elem => elem.ActingDeptGroupId === data.ActingDeptGroupId)) {
                                    // total Approval count
                                    ApprovalDepartments.find(elem => elem.ActingDeptGroupId === data.ActingDeptGroupId).TotalApprovalCount = ApprovalDepartments.find(elem => elem.ActingDeptGroupId === data.ActingDeptGroupId).TotalApprovalCount + 1

                                    if (data.approvalStatus == 1) { // total approved count
                                        ApprovalDepartments.find(elem => elem.ActingDeptGroupId === data.ActingDeptGroupId).ApprovedCount = ApprovalDepartments.find(elem => elem.ActingDeptGroupId === data.ActingDeptGroupId).ApprovedCount + 1
                                    }
                                } else {
                                    ApprovalDepartments.push({
                                        "ActingDeptGroupId": data.ActingDeptGroupId,
                                        "TotalApprovalCount": 1,
                                        "ShortDeptName": data.ShortDeptName,
                                        "ApprovedCount": data.approvalStatus == 1 ? 1 : 0
                                    })
                                }
                            }
                        })
                    }
                }
                invoiceTableData[i].approvalDetails = approvalDetailsPartial.find(elem => elem.DocumentId == parseInt(element.InvoiceDocId)) ? approvalDetailsPartial : approvalDetails
                invoiceTableData[i].ApprovalDepartments = ApprovalDepartments
                // prepare CSV Data
            }
            await this.setState({ invoiceTableData, totalPos, loading: false })
        }
    }
    toggleFilter = async () => {
        this.setState({ isShowFilter: !this.state.isShowFilter })
    }
    getFilterList = async () => {
        await this.props.GetFilterList()
        let finalvendorlist = []
        let finalpos = []
        let finalwbsno = []
        let finalplantcode = []
        await this.props.filterList[1].map(async (item) => {
            await finalplantcode.push({ label: item.PlantCode, value: item.PlantCode })
        })
        await this.props.filterList[2].map(async (item) => {
            await finalwbsno.push({ label: item.WBSCode, value: item.WBSCode })
        })
        await this.props.filterList[3].map(async (item) => {
            await finalvendorlist.push({ label: item.VendorName, value: item.VendorName })
        })
        await this.props.filterList[4].map(async (item) => {
            await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
        })

        let POSAPId = []
        let WBSCode = []
        let PlantCode = []
        let VendorName = []
        let searchForItem = []
        await this.state.sortByPlantCode.map(async (item) => {
            await PlantCode.push({ label: item, value: item })
        })
        await this.state.sortByWBS.map(async (item) => {
            await WBSCode.push({ label: item, value: item })
        })
        await this.state.sortByPo.map(async (item) => {
            await POSAPId.push({ label: item, value: item })
        })
        await this.state.sortByVendor.map(async (item) => {
            await VendorName.push({ label: item, value: item })
        })
        if (this.state.searchFor) {
            await searchForItem.push({ label: this.state.searchFor, value: this.state.searchFor })
        }
        await this.setState({ finalvendorlist, finalpos, finalwbsno, finalplantcode, PlantCode, WBSCode, POSAPId, VendorName, searchForItem })
    }
    handleSelectPO = async (e) => {
        let sortByPo = []
        let POSAPId = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPo.push(item.value)
                POSAPId.push(item)
            })
        }
        await this.setState({ sortByPo, POSAPId })
        await this.filterData()
    }
    handleSelectWBS = async (e) => {
        let sortByWBS = []
        let WBSCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByWBS.push(item.value)
                WBSCode.push(item)
            })
        }
        await this.setState({ sortByWBS, WBSCode })
        await this.filterData()
    }
    handleSelectPlantCode = async (e) => {
        let sortByPlantCode = []
        let PlantCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPlantCode.push(item.value)
                PlantCode.push(item)
            })
        }
        await this.setState({ sortByPlantCode, PlantCode })
        await this.filterData()
    }
    handleSelectVendor = async (e) => {
        let sortByVendor = []
        let VendorName = []
        if (e.length > 0) {
            e.map((item) => {
                sortByVendor.push(item.value)
                VendorName.push(item)
            })
        }
        await this.setState({ sortByVendor, VendorName })
        await this.filterData()
    }
    render() {
        const dropdowndata = [], multidropdowndata = []
        var roles = authInstance.getRoles()
        var groups = authInstance.getGroups()
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }
        console.log(this.state.invoiceTableData, "invoiceTableData")

        if (this.props.masterReducerData.loading == false) {
            this.state.paymentMethod = this.props.masterReducerData.masterdata.recordset
        }


        try {
            {
                this.props.allpo.polist && this.props.allpo.polist.recordset && this.props.allpo.polist.recordset.length > 0 && this.props.allpo.polist.recordset.map((element, Index) =>
                    dropdowndata.push(element)
                )
            }

            {
                this.props.allpoitem.poitemlist && this.props.allpoitem.poitemlist.recordset && this.props.allpoitem.poitemlist.recordset.length > 0 && this.props.allpoitem.poitemlist.recordset.map((element, Index) =>
                    // if (element.POLineItemSAPCode) {
                    multidropdowndata.push({ label: element.POLineItemSAPCode, value: element.PurchaseOrderLineId })
                    // multidropdowndata.push(element)
                    // }
                )
            }
        } catch (error) { }

        var date = new Date();
        var Curr_Day = this.fetchDate(date)
        var lastDay = new Date(date.getFullYear(), date.getMonth(), this.daysInMonth(date.getMonth() + 1, date.getFullYear()));
        var finalLastDay = this.fetchDate(lastDay)
        var varId = this.state.varId
        console.log(this.state.invoiceTableData, "JDKDJDKDJDKDJDKDJ")
        return (

            <div className="Container-fluid pl-2 pr-2 pt-2"  >
                {/*----------Document comment-------------- */}
                {
                    varId ? (<DocumentCommentAdvancePopUp action={this.state.DocumentCommentAdvancePopUpModal} toggleDocumentCommentAdvancePopUpModal={(e) => this.toggleDocumentCommentAdvancePopUpModal(e)} InvoiceId={varId} path='/AdvancedReceivePayments' />) : null
                }
                {/*----------Document Comment end  */}
                {/* upload modal starts */}
                <Modal isOpen={this.state.uploadModal}>
                    <ModalHeader HeaderStyle=" modal-header modalbodysmall  ">
                        <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Upload Invoice</h4>
                        <button type="button" className="close" aria-label="Close" onClick={this.uploadmodal} style={{ color: 'black' }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </ModalHeader>
                    <ModalBody Style="modal-body modalbody">
                        <div className="row mt-2">
                            <div className="col pt-2  ">
                                <div className="row">
                                    <div className="col-md-5"><b>PO No : </b></div>
                                    <div className="col-md-7">
                                        <DropdownFlat defaultopt="Select Option" data={dropdowndata} keyObjName={"PurchaseOrderId"} valueObjName={"POSAPId"} actions={this.handleClickPoDropdown} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col pt-2">
                                <div className="row">
                                    <div className="col-md-5"><b>PO LineItem No : </b></div>
                                    <div className="col">
                                        <Select isMulti
                                            mode="multiple"
                                            options={multidropdowndata}
                                            className="select-itemNo"
                                            onChange={(e) => this.handleClickMultiPoDropdown(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col pt-2 ">
                                <div className="row">
                                    <div className="col-md-5"><b>Upload File : </b></div>
                                    <div className="col-sm-5">
                                        <input type="file" className="form-control-file" name="" onChange={(e) => this.handleFileInput(e)} id="exampleFormControlFile2" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter FooterStyle="modal-footer modalbodysmall">
                        <div>
                            <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.Submitmodal} type="submit">Save</button>
                            <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.uploadmodal} type="submit">Cancel</button>
                        </div>
                    </ModalFooter>
                </Modal>
                {/* upload modal ends */}

                <div className="row pl-3 header">
                    <b>ALL INVOICES</b>
                </div>
                <div className="row pr-4" >
                    <div className='col-md-6 pt-2'>
                        {/* <button className="btn2 btn-sms1 float-right rounded-pill" onClick={() => this.getInvoices()}>export</button>
                        <CSVLink data={this.state.csvData} ref={this.csvLinkEl} filename='Invoice' /> */}
                    </div>
                    <div className="col-md-6 pt-2  xs={last}">
                        <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" toggleFilter={this.toggleFilter} clearFilter={this.clearFilter} filter={true} clear={true} btnName="" ShowSearchFor={true} searchForOptions={this.state.searchForOptions} searchForItem={this.state.searchForItem} SelectSearchForHandler={this.handleSelectSearchFor} />
                    </div>
                </div>
                {this.state.isShowFilter ?
                    <div className="row justify-content-between pb-3 pt-3 m-0 border-radius-modal filter-data pr-2 pl-2">
                        <div className="col">
                            <Select maxMenuHeight={500} placeholder="Project No." isMulti value={this.state.WBSCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalwbsno} onChange={(e) => this.handleSelectWBS(e)} />
                        </div>
                        <div className="col">
                            <Select maxMenuHeight={500} placeholder="Vendor" isMulti value={this.state.VendorName} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalvendorlist} onChange={(e) => this.handleSelectVendor(e)} />
                        </div>
                        <div className="col">
                            <Select maxMenuHeight={500} placeholder="Plant" isMulti value={this.state.PlantCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalplantcode} onChange={(e) => this.handleSelectPlantCode(e)} />
                        </div>
                        <div className="col">
                            <Select maxMenuHeight={500} placeholder="PO No." isMulti value={this.state.POSAPId} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalpos} onChange={(e) => this.handleSelectPO(e)} />
                        </div>
                    </div>
                    : null}
                {this.state.loading == true ?
                    <div className="backdrop">
                        <Loading />
                    </div>
                    :
                    <>
                        <div className="row mt-2 sticky">
                            <div className="col-md-12 centre-alligned  wrap">
                                <Table className="table1 table-exp text-left" height="">
                                    <thead className=" sticky-inner" style={{ height: "3vh" }}>
                                        <tr>
                                            <th className="align-middle" style={{ position: "relative", width: "5%" }} >Action</th>
                                            {!roles[5] ? <th className="align-middle" style={{ position: "relative", width: "7%" }} >Invoice Doc. Approval Status</th> : null}
                                            <th className="align-middle" style={{ position: "relative", width: "7%" }}>Invoice Type</th>
                                            <th className="align-middle" style={{ position: "relative", width: "7%" }}>Vendor Name</th>
                                            <th className="align-middle" style={{ whiteSpace: "break-spaces", position: "relative", width: "7%" }}>Plant Code</th>
                                            <th className="align-middle" style={{ whiteSpace: "break-spaces", position: "relative", width: "7%" }}>Project Code</th>
                                            <th className="align-middle" style={{ position: "relative", width: "7%" }}>PO No</th>
                                            <th className="align-middle" style={{ position: "relative", width: "7%" }}>Invoice No</th>
                                            <th className="align-middle" style={{ position: "relative", width: "7%" }}>Invoice Date</th>
                                            <th className="align-middle" style={{ position: "relative", width: "7%" }}>Due Date</th>
                                            <th className="align-middle" style={{ whiteSpace: "break-spaces", position: "relative", width: "7%" }}>Invoice Amount(INR)
                                            </th>
                                            <th className="align-middle" style={{ position: "relative", width: "7%" }}>Net Payable</th>
                                            <th className="align-middle" style={{ position: "relative", width: "7%" }}>Paid Amount</th>
                                            <th className="align-middle" style={{ position: "relative", width: "7%" }}>Final Approval</th>
                                            <th className="align-middle" style={{ position: "relative", width: "7%" }}>Payment Date</th>
                                        </tr>
                                    </thead>
                                    {this.state.invoiceTableData.length > 0 && this.state.invoiceTableData.map((element, Index) =>
                                        <tbody key={Index} >
                                            <tr onClick={() => this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                                                <td className="align-middle text-center">
                                                    {element.InvoiceTypeId === 5 ?

                                                        <Link to={{ pathname: '/ImportLogistics' }}>
                                                            <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" />
                                                        </Link>
                                                        :
                                                        <Link to={{ pathname: '/PoAcceptanceTrail', state: { poId: element.PurchaseOrderId, poSAPId: element.POSAPId, InvoiceId: element.InvoiceId, InvoiceStatusId: element.InvoiceStatusId } }}>
                                                            <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" />
                                                        </Link>
                                                    }
                                                </td>
                                                {!roles[5] ?
                                                    <td className="align-middle text-center">
                                                        {element.ApprovalDepartments && element.ApprovalDepartments.filter((elem) => elem.ActingDeptGroupId == 19).length == 0 && element.PaymentType == 2 ? element.approvalDetails.find((data) => (data.TypeFor == element.TypeFor || data.TypeFor == null) && data.PaymentType == element.InvoiceTypeId && data.approvalStatus == 1 && data.ActedGroupId == 19 && data.DocumentTypeId == 0) ?
                                                            <div className="float-left ml-1" style={{ display: "flex", flexDirection: "row" }}>
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={100}>
                                                                    <span style={{ fontSize: '10px', color: 'black', fontWeight: 'bold' }}>PM</span>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                            : <div className="float-left ml-1">
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={0}>
                                                                    <div style={{ fontSize: '10px', color: 'black', fontWeight: 'bold' }}>PM</div>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                            // : null
                                                            : null
                                                        }
                                                        {element.ApprovalDepartments && element.ApprovalDepartments.filter((data) => data.ActingDeptGroupId == 26).length == 0 && element.PaymentType == 2 ? element.approvalDetails.find((data) => (data.TypeFor == element.TypeFor || data.TypeFor == null) && data.PaymentType == element.InvoiceTypeId && data.approvalStatus == 1 && data.ActedGroupId == 26 && data.DocumentTypeId == 0) ?
                                                            <div className="float-left ml-1" style={{ display: "flex", flexDirection: "row" }}>
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={100}>
                                                                    <div style={{ fontSize: '10px', color: 'black', fontWeight: 'bold' }}>CM</div>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                            : <div className="float-left ml-1">
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={0}>
                                                                    <div style={{ fontSize: '10px', color: 'black', fontWeight: 'bold' }}>CM</div>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                            // : null
                                                            : null
                                                        }
                                                        {element.ApprovalDepartments && element.ApprovalDepartments.filter((data) => data.ActingDeptGroupId == 7).length == 0 && element.PaymentType != 2 ? element.approvalDetails.find((data) => (data.TypeFor == element.TypeFor || data.TypeFor == null) && data.PaymentType == element.InvoiceTypeId && data.approvalStatus == 1 && data.ActedGroupId == 7 && data.DocumentTypeId == 0) ?
                                                            <div className="float-left ml-1" style={{ display: "flex", flexDirection: "row" }}>
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={100}>
                                                                    <div style={{ fontSize: '10px', color: 'black', fontWeight: 'bold' }}>EXP</div>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                            : <div className="float-left ml-1">
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={0}>
                                                                    <div style={{ fontSize: '10px', color: 'black', fontWeight: 'bold' }}>EXP</div>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                            : null
                                                        }
                                                        {element.ApprovalDepartments && element.ApprovalDepartments.map((elem, index) =>
                                                            <div key={index} className="float-left ml-1" style={{ display: "flex", flexDirection: "row" }}>
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={Math.round((elem.ApprovedCount / elem.TotalApprovalCount) * 100)}>
                                                                    <div style={{ fontSize: '10px', color: 'black', fontWeight: 'bold' }}>{elem.ShortDeptName}</div>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                        )}
                                                    </td>
                                                    : null}
                                                <td className="align-middle headeralign" style={{ width: "50px" }}>{element.InvoiceTypeName + (element.TypeFor ? ' against ' + element.TypeFor : '') + (element.InvoiceTypeId == 3 ? " - " + (element.Counter + 1) : '')}</td>
                                                <td className="align-middle headeralign" style={{ width: "50px" }}>{element.VendorName + ' - ' + element.VendorSapId}</td>
                                                <td className="align-middle text-center">{element.PlantCode}</td>
                                                <td className="align-middle headeralign">{element.WBSCode ? element.WBSCode.includes('ET') ? (element.WBSCode).slice(0, 11) : (element.WBSCode).slice(0, 6) : ""}</td>
                                                <td className="align-middle headeralign">{element.POSAPId}</td>
                                                <td className="align-middle headeralign">
                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.InvoiceDocId + "/download"} target="_blank" download>
                                                        {element.InvoiceNo}
                                                    </a>
                                                    <span className="badge badge-warning ml-2">{element.InvoiceTypeId !== 3 && element.Counter > 0 ? `Part-${element.Counter}` : ''}</span>
                                                </td>
                                                <td className="align-middle text-center">{element.InvoiceDate ? dateFormater(element.InvoiceDate) : ""}</td>
                                                <td className="align-middle text-center" style={{ whiteSpace: "nowrap" }}>{element.DueDate ? dateFormater(element.DueDate) : ""}</td>
                                                <td className="align-middle amount-text">{element.InvoiceAmountinINR ? numberWithCommas(element.InvoiceAmountinINR) : ""}</td>
                                                <td className="align-middle amount-text">{element.NetPayableAmount ? numberWithCommas(element.NetPayableAmount) : ""}</td>
                                                <td className="align-middle amount-text">{element.TotalPaidAmount ? numberWithCommas(element.TotalPaidAmount) : "0"}</td>
                                                <td className="align-middle text-center">{element.ApprovalDate ? dateFormater(element.ApprovalDate) : ""}</td>
                                                <td className="align-middle text-center">{element.paymentDate ? dateFormater(element.paymentDate) : ""}</td>
                                            </tr>
                                            <tr style={{ maxWidth: "100%", position: "relative", width: "100%", zIndex: "99" }} className={Index == this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${Index}` : `container collapse`}>
                                                <td colSpan={'15'}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Invoice Type:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.InvoiceTypeName + (element.TypeFor ? ' against ' + element.TypeFor : '')}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Vendor Type:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.SSIType == "" ? "NON MSME" : "MSME"}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Invoice Amount:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.CurrencyType + ' ' + numberWithCommas(element.InvoiceAmount)}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Advance Deduction:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.CurrencyType + ' ' + (element.AdvanceDeduction && element.AdvanceDeduction != null ? numberWithCommas(element.AdvanceDeduction) : '0.00')}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Retention Deduction:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.CurrencyType + ' ' + (element.RetentionDeduction && element.RetentionDeduction != null ? numberWithCommas(element.RetentionDeduction) : '0.00')}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>LD Deduction:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.CurrencyType + ' ' + (element.LDDeduction && element.LDDeduction != null ? numberWithCommas(element.LDDeduction) : '0.00')}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>TDS Deduction:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.CurrencyType + ' ' + (element.TDSDeduction && element.TDSDeduction != null ? numberWithCommas(element.TDSDeduction) : '0.00')}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Others Deduction:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.CurrencyType + ' ' + (element.OthersDeduction && element.OthersDeduction != null ? numberWithCommas(element.OthersDeduction) : '0.00')}
                                                                </div>
                                                            </div>

                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Reason For Others:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.ReasonForOthersDeduction ? element.ReasonForOthersDeduction : ''}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Vendor Address:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.VendorAddress ?
                                                                        <>
                                                                            {element.VendorAddress}
                                                                            <br />
                                                                        </>
                                                                        : null
                                                                    }
                                                                    {element.VendorAddress1 ?
                                                                        <>
                                                                            {element.VendorAddress1}
                                                                            <br />
                                                                        </>
                                                                        : ""}
                                                                    {element.VendorAddress2 ?
                                                                        <>
                                                                            {element.VendorAddress2}
                                                                            <br />
                                                                        </>
                                                                        : ""}
                                                                    {(element.VendorState ? element.VendorState : "") + " - " + (element.VendorCity ? element.VendorCity : "")}
                                                                    <br />
                                                                    {element.VendorCountry ? element.VendorCountry : ""}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Vendor GSTIn:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.VendorGstin}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Utr No:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.utrNo ?
                                                                        roles[8] && groups[9] ?
                                                                            <div className="row">
                                                                                <div className="col-md-9">
                                                                                    <input type="text" value={this.state.EditedUtrNo ? this.state.EditedUtrNo : element.utrNo} className="form-control" style={{ width: "100%", height: "86%" }} onChange={(e) => this.handleUtrNo(e)} />
                                                                                </div>
                                                                                <div className="col-md-3">
                                                                                    <FontAwesomeIcon icon={"check-circle"} color={"green"} title="Save" size="lg" cursor="pointer" onClick={() => this.handleClickSaveUtrNo(element.InvoiceId)} />
                                                                                </div>
                                                                            </div>
                                                                            : element.utrNo
                                                                        : ""
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Payment Advice no:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.PaymentInformationNo}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>SAP Doc no:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.SAPDocNo}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>SAP Doc Date:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {dateFormater(element.SAPDocDate)}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Payment Method:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.PaymentMediumName}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Status:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.InvoiceStatusName}
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="col-md-7">
                                                                    <b>Payment Advice:</b>
                                                                </div>
                                                                <div className="col">
                                                                    {element.paymentAcknowledgementDocumentId ?
                                                                        <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.paymentAcknowledgementDocumentId + "/download"} target="_blank" download>
                                                                            <FontAwesomeIcon className="align-middle pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                                        </a>
                                                                        :
                                                                        <FontAwesomeIcon className="align-middle pr-2" icon={"stopwatch"} title="Yet To Be Paid" color={"grey"} size="2x" />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    )}
                                </Table>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "3%" }}>
                            <hr></hr>
                            <PaginationComponent filteredTodos={this.state.invoiceTableData} currentPage={this.state.currentPage} posPerpage={this.state.posPerpage} totalPos={this.state.totalPos} handleClick={this.handleClick} handleSelectPoPerPage={this.handleSelectPoPerPage} showPosPerpage={true} />
                            <hr></hr>
                        </div>
                    </>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({ allpo: state.poDetailsReducer, allpoitem: state.poDetailsReducer, invoices: state.invoice, masterReducerData: state.masterReducer, filterList: state.masterReducer.filterList, poDetails: state.poDetails })
export default connect(mapStateToProps, { getAllInvoices, GetAllPOListByUserId, getDueAmounts, GetPOLineItemByPOId, setInvoicePaymentMedium, getallMasterData, updateStatusForFinance, GetAllInvoicesForSupplier, postMapPaymentAcknowledgementDocumentIDsToInvoice, PaymentTermDocumentsApprovalByPMs, getPaymentTermDocuments, GetFilterList, getProjectAllocationByUserId })(ReqPayment)
